import { DEFAULT_ALL_VALUE } from '@chronosphereio/core';
import { SelectOption } from '../Select';

interface SortOptionsParams {
  options: SelectOption[];
  selectedOptions: SelectOption[];
}

export const sortOptions = ({ options, selectedOptions }: SortOptionsParams) => {
  // Move selected values to the front of the options array so they are shown first in the dropdown
  const selectedOptionKeys = new Set(selectedOptions.map((s) => s.key));
  const sorted = [...selectedOptions, ...options.filter((option) => !selectedOptionKeys.has(option.key))];

  // if '$_all' key is found, keep it at the beginning of the array
  const allIndex = sorted.findIndex((obj) => obj['key'] === DEFAULT_ALL_VALUE);
  if (allIndex !== -1) {
    const allItem = sorted.splice(allIndex, 1)[0]; // Remove "All" option from its original position and get it
    if (allItem) {
      sorted.unshift(allItem); // Add "All" option to the beginning of the array
    }
  }

  return sorted;
};
